import { Col, Text } from 'components';
import { theme } from 'lib';

/**
 * A settings card: titled, optionally described, on a grey panel.
 *
 * `nested` is for a card that sits INSIDE another Section. It only flips the fill to white —
 * grey-on-grey reads as one flat block however the border is drawn, whereas white-on-grey makes
 * the containing card legible as the group it is. Radius, border and padding stay identical, so
 * a nested card is visibly the same kind of object as a top-level one.
 */
const Section = ({ title, description, children, nested }) => (
  <Col
    noFlex
    stretch
    wid="100%"
    pad="20px"
    style={{
      backgroundColor: nested ? theme.PRIMARY_WHITE || '#fff' : theme.GREY_10 || '#f9f9f9',
      borderRadius: '12px',
      border: `1px solid ${theme.GREY_20 || '#eee'}`
    }}
  >
    <Text h4 bold marg="0 0 4px">
      {title}
    </Text>
    {description && (
      <Text c1 col={theme.GREY_60} marg="0 0 16px">
        {description}
      </Text>
    )}
    {children}
  </Col>
);

export default Section;
